import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

export const getChatHistoryBySession = async (sessionId: string | null) => {
  try {
    const response = await Axios.get(`/chat_logs/get/${sessionId}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetChatHistoryBySession = ({
  sessionId,
}: {
  sessionId: string | null;
}) => {
  const sessions = useQuery({
    queryKey: ['get_chat_history_by_session', sessionId],
    queryFn: () => getChatHistoryBySession(sessionId),
    enabled: !!sessionId,
  });

  return sessions;
};
